module.exports = __webpack_public_path__ + "static/integration-c4305e835ec433c74412f964bdd8a5f1.png";